import { ProductPTEditor } from "./ProductPTEditor";
import { FormConfirmDialog } from "@/components/FormConfirmDialog";

import type { Control } from "react-hook-form";
import type { ProductPTEditorState } from "./ProductPTEditor";

export function ProductPTEditorDialog({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  control,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void | PromiseLike<void>;
  loading: boolean;
  control: Control<ProductPTEditorState>;
}) {
  return (
    <FormConfirmDialog
      control={control}
      title={title}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onSubmit}
    >
      <ProductPTEditor control={control} />
    </FormConfirmDialog>
  );
}
